<template>
    <b-card>
        <b-row>
            <b-col lg="12">
                <b-card header="Filter"
                        header-text-variant="white"
                        header-bg-variant="info"
                >
                    <b-form inline @submit.prevent="fetch()">
                        <b-form-select
                            id="roles_filter"
                            name="roles_filter"
                            v-model="roles_filter"
                        >
                            <option value="caregiver">Providers</option>
                            <option value="client">Claimants</option>
                            <option value="all">All Users</option>
                        </b-form-select>
                        &nbsp;
                        <b-form-select
                            id="method_filter"
                            name="method_filter"
                            v-model="method_filter"
                        >
                            <option value="name">Match by Name</option>
                            <option value="phone">Match by Phone Number</option>
                            <option value="email">Match by Email Address</option>
                        </b-form-select>
                        &nbsp;
                        <b-button type="submit" variant="info" :disabled="loading">Generate Report</b-button>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>

        <div class="table-responsive">
            <div class="text-right mb-3">
                <b-btn variant="success" :href="`${url}&export=1`" :disabled="loading">
                    <i class="fa fa-file-excel-o"></i> Export to Excel
                </b-btn>
            </div>

            <loading-card v-if="loading"></loading-card>

            <b-table bordered striped hover show-empty
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                v-else
            >
                <template v-slot:cell(id)="row">
                    <b-btn size="sm" :href="`/business/${row.item.role_type}s/${row.item.id}`">Edit</b-btn>
                </template>
            </b-table>
        </div>
    </b-card>
</template>

<script>
    import FormatsDates from "../../../mixins/FormatsDates";
    // import FormatsStrings from "../../../mixins/FormatsStrings";
    import EnrollmentStatuses from '../../../mixins/EnrollmentStatuses';

    export default {
        mixins: [ FormatsDates, EnrollmentStatuses ],

        props: ['data'],

        data() {
            return {
                items: [],
                totalItems: 0,
                sortBy: 'lastname',
                sortDesc: false,
                loading: false,
                roles_filter: 'all',
                method_filter: 'name',
                fields: [
                    {
                        key: 'firstname',
                        sortable: true,
                        label: 'First',
                    },
                    {
                        key: 'lastname',
                        label: 'Last',
                        sortable: true,
                    },
                    {
                        key: 'role_type',
                        label: 'Role',
                        sortable: true,
                        formatter: this.stringFormat,
                    },
                    {
                        key: 'city',
                        label: 'City',
                        sortable: true,
                    },
                    {
                        key: 'zip',
                        label: 'Zipcode',
                        sortable: true,
                    },
                    {
                        key: 'phone_numbers',
                        label: 'Phone',
                        sortable: true,
                        formatter: x => {
                            return x ? x.join(', ') : '-';
                        },
                    },
                    {
                        key: 'email',
                        sortable: true,
                    },
                    {
                        key: 'enrollment_status',
                        sortable: true,
                        formatter: this.formatEnrollmentStatus,
                    },
                    {
                        key: 'enrolled_pairs',
                        sortable: true,
                    },
                    {
                        key: 'unenrolled_pairs',
                        sortable: true,
                    },
                    {
                        key: 'visits',
                        sortable: true,
                    },
                    {
                        key: 'id',
                        label: 'Actions',
                    },
                ]
            }
        },

        computed: {
            url() {
                return `/business/reports/duplicate-users?json=1&roles=${this.roles_filter}&match=${this.method_filter}`;
            }
        },

        methods: {
            fetch() {
                this.loading = true;
                axios.get(this.url)
                    .then( ({ data }) => {
                        this.items = data;
                        this.totalItems = this.items.length;
                    })
                    .finally( () => this.loading = false );
            },

            details(item) {
                axios.get('/business/shifts/' + item.id)
                    .then(response => {
                        let shift = response.data;
                        shift.checked_in_time = moment.utc(shift.checked_in_time).local().format('L LT');
                        shift.checked_out_time = moment.utc(shift.checked_out_time).local().format('L LT');
                        this.selectedItem = shift;
                        this.detailsModal = true;
                    })
                    .catch(e => {
                        alert('Error loading shift details');
                    });
            },

            formatEnrollmentStatus(value) {
                if (value === 'sent_agreement') {
                    return 'Enrollment Material Sent';
                } else if (this.isIncomplete(value)) {
                    return 'Incomplete';
                }
                return this.stringFormat(value);
            },
        },

        mounted() {
            this.items = this.data;
            this.totalItems = this.items.length;
        },
    }
</script>
